import { IGetHospitalAction, IGetHospitalsAction } from './hospitalDetail.interface';

export enum HospitalDetailTypes {
  GET_HOSPITAL = 'GET_HOSPITAL',
  GET_HOSPITALS = 'GET_HOSPITALS',
}

export type HospitalDetailAction = IGetHospitalAction | IGetHospitalsAction;
